import { render, staticRenderFns } from "./EndRegistration.vue?vue&type=template&id=aeb6f738"
import script from "./EndRegistration.vue?vue&type=script&lang=js"
export * from "./EndRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports